// PLAN-cockpit-v2-iter1: Header search ⇔ Explore search の値同期 (2026-05-11)
// sessionStorage 'explore_q' を source of truth として両方の入力が共有する
import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'explore_q'
const EVENT_NAME = 'global_q_change'

function read(): string {
  try { return window.sessionStorage.getItem(STORAGE_KEY) ?? '' } catch { return '' }
}

export function useGlobalSearchQuery() {
  const [q, setQState] = useState<string>(read)

  useEffect(() => {
    const handler = () => {
      const v = read()
      setQState(prev => (prev !== v ? v : prev))
    }
    window.addEventListener(EVENT_NAME, handler)
    return () => window.removeEventListener(EVENT_NAME, handler)
  }, [])

  const setQ = useCallback((v: string) => {
    setQState(v)
    try { window.sessionStorage.setItem(STORAGE_KEY, v) } catch { /* ignore */ }
    window.dispatchEvent(new CustomEvent(EVENT_NAME))
  }, [])

  return [q, setQ] as const
}
